import {Tabs, TabsContent, TabsList, TabsTrigger} from "../../../basic/tabs.tsx";
import {LicenseTable} from "./LicenseTable.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpLicense} from "../../../../store/generated/api.ts";

interface LicenseTabsProps {
    licenses: VwpLicense[];
}

export function LicenseTabs({licenses}: LicenseTabsProps) {
    const {t} = useTranslationWithKeys();

    return (
        <Tabs defaultValue="all">
            <TabsList>
                <TabsTrigger value="all">{t('licenses.allLicenses')}</TabsTrigger>
                <TabsTrigger value="active">{t('licenses.statusValues.active')}</TabsTrigger>
                <TabsTrigger value="expiring">{t('licenses.statusValues.expiring')}</TabsTrigger>
            </TabsList>
            <TabsContent value="all" className="mt-4">
                <LicenseTable licenses={licenses} filter="all"/>
            </TabsContent>
            <TabsContent value="active" className="mt-4">
                <LicenseTable licenses={licenses} filter="active"/>
            </TabsContent>
            <TabsContent value="expiring" className="mt-4">
                <LicenseTable licenses={licenses} filter="expiring"/>
            </TabsContent>
        </Tabs>
    );
}